import React, { ChangeEvent, useRef, useState } from 'react';

import { ClearIcon, IconWrapper, Input, InputWrapper, SearchIcon, SearchIndicator, Wrapper } from './styled';

type Props = {
  initialValue?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
};

const SearchInput = ({ initialValue, onChange, placeholder = 'Search Report' }: Props): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(!!initialValue);
  const [value, setValue] = useState(initialValue);

  const [prevInitialValue, setPrevInitialValue] = useState(initialValue);
  if (initialValue !== prevInitialValue) {
    setPrevInitialValue(initialValue);
  }

  if (initialValue === '' && prevInitialValue !== '') {
    setValue('');
  }

  const inputRef = useRef<HTMLInputElement>(null);
  const handleChange = ({ target: { value } }: ChangeEvent<HTMLInputElement>): void => {
    setValue(value);
    onChange?.(value);
  };

  const handleClear = (): void => {
    onChange?.('');
    setValue('');
  };

  const toggleExpand = (): void => {
    setIsExpanded((value) => !value);
    !isExpanded && inputRef.current?.focus();
  };

  return (
    <Wrapper>
      <IconWrapper data-testid="searchButton" onClick={toggleExpand} $isExpanded={isExpanded}>
        <SearchIcon />
      </IconWrapper>
      <InputWrapper data-testid="searchBox" $isExpanded={isExpanded}>
        <Input
          data-testid="searchInput"
          ref={inputRef}
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onBlur={(): void => {
            if (!value || !value.length) {
              toggleExpand();
            }
          }}
        />
        {Boolean(value?.length) && (
          <ClearIcon
            data-testid="clearButton"
            onClick={(): void => {
              handleClear();
              inputRef.current?.focus();
            }}
          />
        )}
        <SearchIndicator />
      </InputWrapper>
    </Wrapper>
  );
};

export default SearchInput;
